<div>
  <header class="header">
    <div class="vertical-align">
      <img src="/assets/svg/logo-rodobens.svg" loading="lazy" decoding="async" width="165" height="42" 
      class="ic-logo"
        title="Rodobens" alt="Rodobens Logo" width="165" height="42">
    </div>
  </header>
</div>